import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';

const SlideContainer = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 1rem;
  padding-top: 4.5rem;
  overflow-y: auto;

  @media (max-width: 768px) {
    padding: 0.8rem;
    padding-top: 4rem;
    height: 100vh;
  }

  @media (max-width: 480px) {
    padding: 0.5rem;
    padding-top: 3.5rem;
    height: 100vh;
  }
`;

const ContentContainer = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  z-index: 5;
`;

const SlideTitle = styled(motion.h2)`
  font-size: 3.5rem;
  font-weight: 800;
  text-align: center;
  margin-bottom: 1rem;
  background: linear-gradient(45deg, #6F1A3F, #C82B3F);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  word-break: break-word;
  position: relative;
  z-index: 1;
  width: 100%;

  @media (max-width: 1024px) {
    font-size: 3rem;
    margin-bottom: 0.8rem;
  }

  @media (max-width: 768px) {
    font-size: 2rem;
    margin-bottom: 0.6rem;
  }

  @media (max-width: 480px) {
    font-size: 1.6rem;
    margin-bottom: 0.5rem;
  }

  @media (max-width: 360px) {
    font-size: 1.4rem;
    margin-bottom: 0.4rem;
  }
`;

const ContentGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
  width: 100%;
  align-items: start;

  @media (max-width: 1024px) {
    gap: 1.5rem;
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 1.2rem;
  }

  @media (max-width: 480px) {
    gap: 1rem;
  }
`;

const TextContent = styled.div`
  color: #ccc;
  line-height: 1.8;
`;

const Description = styled(motion.p)`
  font-size: 1.4rem;
  margin-bottom: 1rem;
  color: #fff;
  font-weight: 300;
  line-height: 1.5;

  @media (max-width: 1024px) {
    font-size: 1.3rem;
    margin-bottom: 0.8rem;
  }

  @media (max-width: 768px) {
    font-size: 1.1rem;
    margin-bottom: 0.6rem;
  }

  @media (max-width: 480px) {
    font-size: 1rem;
    margin-bottom: 0.5rem;
  }
`;

const InfoGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.5rem;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 1rem;
  }

  @media (max-width: 480px) {
    gap: 0.8rem;
  }
`;

const InfoItem = styled(motion.div)`
  background: rgba(111, 26, 63, 0.1);
  border: 1px solid rgba(111, 26, 63, 0.3);
  padding: 1.5rem;
  border-radius: 10px;
  text-align: center;
  transition: all 0.3s ease;

  &:hover {
    background: rgba(111, 26, 63, 0.2);
    border-color: rgba(200, 43, 63, 0.5);
    transform: translateY(-5px);
  }

  @media (max-width: 768px) {
    padding: 1.2rem;
  }

  @media (max-width: 480px) {
    padding: 1rem;
  }
`;

const InfoLabel = styled.div`
  font-size: 0.9rem;
  color: #888;
  margin-bottom: 0.5rem;
  font-weight: 500;

  @media (max-width: 768px) {
    font-size: 0.85rem;
  }

  @media (max-width: 480px) {
    font-size: 0.8rem;
  }
`;

const InfoValue = styled.div`
  font-size: 1.2rem;
  color: #fff;
  font-weight: 600;

  @media (max-width: 768px) {
    font-size: 1.1rem;
  }

  @media (max-width: 480px) {
    font-size: 1rem;
  }
`;

const StatsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 2rem;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }

  @media (max-width: 480px) {
    gap: 1rem;
  }
`;

const StatItem = styled(motion.div)`
  text-align: center;
  padding: 2rem;
  background: rgba(0, 0, 0, 0.3);
  border-radius: 15px;
  border: 1px solid rgba(111, 26, 63, 0.2);

  @media (max-width: 768px) {
    padding: 1.5rem;
  }

  @media (max-width: 480px) {
    padding: 1.2rem;
  }
`;

const StatNumber = styled.div`
  font-size: 3rem;
  font-weight: 900;
  background: linear-gradient(45deg, #6F1A3F, #C82B3F);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin-bottom: 0.5rem;

  @media (max-width: 1024px) {
    font-size: 2.5rem;
  }

  @media (max-width: 768px) {
    font-size: 2.2rem;
  }

  @media (max-width: 480px) {
    font-size: 2rem;
  }
`;

const StatLabel = styled.div`
  font-size: 1rem;
  color: #ccc;
  font-weight: 500;

  @media (max-width: 768px) {
    font-size: 0.95rem;
  }

  @media (max-width: 480px) {
    font-size: 0.9rem;
  }
`;

const Slide2 = () => {
  const companyInfo = [
    { label: 'Established', value: 'Since 2020' },
    { label: 'Location', value: 'Amman, Jordan' },
    { label: 'Headquarters', value: 'King Hussein Business Park' },
    { label: 'Industry', value: 'Digital Transformation' }
  ];

  const stats = [
    { number: "100+", label: "Government Services Secured" },
    { number: "15+", label: "Websites Created" },
    { number: "5+", label: "Mobile Apps Developed" },
    { number: "20+", label: "Web Applications Deployed" }
  ];

  return (
    <SlideContainer>
      <ContentContainer>
        <SlideTitle
          initial={{ opacity: 1, y: 0 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          Company Overview
        </SlideTitle>

        <ContentGrid>
        <TextContent>
          <Description
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            A comprehensive digital transformation powerhouse combining cutting-edge technology innovation with strategic marketing excellence to empower businesses in the digital age.
          </Description>

          <InfoGrid>
            {companyInfo.map((info, index) => (
              <InfoItem
                key={index}
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: 0.4 + index * 0.1 }}
                whileHover={{ scale: 1.05 }}
              >
                <InfoLabel>{info.label}</InfoLabel>
                <InfoValue>{info.value}</InfoValue>
              </InfoItem>
            ))}
          </InfoGrid>
        </TextContent>

        <StatsGrid>
          {stats.map((stat, index) => (
            <StatItem
              key={index}
              initial={{ opacity: 0, y: 50 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.6 + index * 0.1 }}
              whileHover={{ scale: 1.05 }}
            >
              <StatNumber>{stat.number}</StatNumber>
              <StatLabel>{stat.label}</StatLabel>
            </StatItem>
          ))}
        </StatsGrid>
        </ContentGrid>
      </ContentContainer>
    </SlideContainer>
  );
};

export default Slide2;
